var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("settings-item", {
        attrs: {
          label: _vm.resource(
            "JourneyComposer_ABTest_Route_Description_DisplayName"
          )
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function(ref) {
              var id = ref.id
              return [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.descriptionModel,
                      expression: "descriptionModel"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { id: id, disabled: !_vm.canWrite },
                  domProps: { value: _vm.descriptionModel },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.descriptionModel = $event.target.value
                    }
                  }
                })
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("settings-item", {
        attrs: {
          label: _vm.resource("JourneyComposer_ABTest_Route_Color_DisplayName")
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c("color-picker", {
                  attrs: { color: _vm.colorModel, enabled: _vm.canWrite },
                  on: {
                    "change-color": function($event) {
                      _vm.colorModel = $event
                    }
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("settings-item", {
        attrs: {
          icon: "fas fa-percentage",
          label: _vm.resource(
            "JourneyComposer_ABTest_Route_Percentage_DisplayName"
          )
        },
        scopedSlots: _vm._u(
          [
            {
              key: "input",
              fn: function(ref) {
                var id = ref.id
                return [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.percentageModel,
                        expression: "percentageModel"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: { id: id },
                      type: "number",
                      min: "1",
                      max: "100",
                      disabled: !_vm.canWrite
                    },
                    domProps: { value: _vm.percentageModel },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.percentageModel = $event.target.value
                      }
                    }
                  })
                ]
              }
            },
            _vm.$v.percentageModel.$invalid && _vm.$v.percentageModel.$dirty
              ? {
                  key: "errors",
                  fn: function() {
                    return [
                      !_vm.$v.percentageModel.minValue
                        ? _c("min-value-error-message", {
                            attrs: {
                              "field-name": _vm.resource(
                                "JourneyComposer_ABTest_Route_Percentage_DisplayName"
                              ),
                              "min-value": 1
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.percentageModel.maxValue
                        ? _c("max-value-error-message", {
                            attrs: {
                              "field-name": _vm.resource(
                                "JourneyComposer_ABTest_Route_Percentage_DisplayName"
                              ),
                              "max-value": 100
                            }
                          })
                        : _vm._e()
                    ]
                  },
                  proxy: true
                }
              : null
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }